import { ColumnMappingOption } from '../types';

export const SCHOOL_COLUMNS: Record<
  string,
  {
    student?: string[];
    mother?: string[];
    father?: string[];
    guardian?: string[];
    generalColumns?: string[];
  }
> = {
  BPIS: {
    student: [
      'student__email',
      'student__enrollmentNo',
      'student__name',
      'student__grade',
      'student__division',
      'student__rollNo',
      'student__house',
      'student__gender',
      'student__aadhar_card_no',
      'student__residential_address',
      'student__date_of_birth',
      'student__religion',
      'student__caste',
      'student__mother_tongue',
      'student__blood_group',
      'student__birth_city',
      'student__birth_country',
      'student__birth_district',
      'student__birth_state',
      'student__birth_taluka',
      'student__res_city',
      'student__res_pincode',
      'student__weight',
      'student__height',
      'student__minority'
    ],
    mother: ['mother__name', 'mother__mobile_no', 'mother__email_id'],
    father: ['father__name', 'father__mobile_no', 'father__email_id'],
    guardian: [],
    generalColumns: []
  }
};

export const getFilteredColumnsForSchool = (
  allColumns: ColumnMappingOption[],
  school: string,
  globalExclusions: string[] = []
): ColumnMappingOption[] => {
  const columnList = SCHOOL_COLUMNS[school];

  if (!columnList) {
    return allColumns.filter(
      (column) => !globalExclusions.includes(column.value)
    );
  }

  return allColumns.filter((column) => {
    const value = column.value;

    if (globalExclusions.includes(value)) return false;

    if (value.startsWith('student')) {
      return columnList.student?.includes(value) ?? true;
    }
    if (value.startsWith('mother')) {
      return columnList.mother?.includes(value) ?? true;
    }
    if (value.startsWith('father')) {
      return columnList.father?.includes(value) ?? true;
    }
    if (value.startsWith('guardian')) {
      return columnList.guardian?.includes(value) ?? true;
    }
    if (columnList.generalColumns?.includes(value)) {
      return false;
    }
    return true;
  });
};
